import { Injectable } from '@angular/core';
import { GeoPoint } from '@core/const';
import { DeliverySlot, DeliverySlotGroupByDate } from '@delivery/const';
import { Store, select } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { DeliveryActions } from '../store/actions';
import { StateWithDelivery } from '../store/delivery-state';
import { DeliverySlotsSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class DeliverySlotsFacade {
  constructor(private store: Store<StateWithDelivery>) {}

  getDeliverySlots(): Observable<DeliverySlot[]> {
    return this.store.pipe(select(DeliverySlotsSelectors.getDeliverySlotsValue), filter<DeliverySlot[]>(Boolean));
  }

  getDeliverySlotsGroupByDate(): Observable<DeliverySlotGroupByDate[]> {
    return this.getDeliverySlots().pipe(
      map((slots: DeliverySlot[]) => {
        return slots.reduce((result: DeliverySlotGroupByDate[], slot: DeliverySlot) => {
          const index = slot.dnd;
          if (result[index]) {
            result[index] = { slots: [...result[index].slots, slot] };
          } else {
            result[index] = { slots: [slot] };
          }

          return result;
        }, []);
      }),
    );
  }

  getDeliverySlotsLoading(): Observable<boolean> {
    return this.store.pipe(select(DeliverySlotsSelectors.getDeliverySlotsLoading));
  }

  getDeliverySlotsState(): Observable<StateUtils.LoaderState<DeliverySlot[]>> {
    return this.store.pipe(select(DeliverySlotsSelectors.getDeliverySlotsState));
  }

  loadDeliverySlots(geoPoint: GeoPoint, weight: number): void {
    this.store.dispatch(new DeliveryActions.LoadDeliverySlots({ geoPoint, weight }));
  }
}
